export default __webpack_public_path__ + "static/media/Trafalgar.e5e99042.jpeg";